<div class="header-title">
  <div class="flex u-align-items-center u-pa-20">
    <div class="flex flex-align-center">
      <a routerLink="/button" aria-label="back"
        class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto" type="button">
        <span class="u-icon icon-chevron-left"></span>
        <span class="u-button-text">Back</span>
      </a>
    </div>
    <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
      <h1 class="font-semibold u-ma-0 flex header-title--name">
        Notification Inline
      </h1>
    </div>
  </div>
  <div class="c-header__gradient"></div>
</div>
<div class="content content--modifier-height">
  <h2>Customized Notification Inline</h2>
  <div class="content__tools-wrap">
    <div class="content__row">
      <label for="type-option" class="content__row-label">type option</label>
      <select [(ngModel)]="type" placeholder="Type" class="c-input-group__control" id="type-option">
        <ng-container *ngFor="let type of typeList">
          <option [value]="type">{{ type }}</option>
        </ng-container>
      </select>
    </div>
    <div class="content__row">
      <div class="c-input-check-inline">
        <input id="hasCloseButton" class="c-input-check-inline__input" type="checkbox" name="hasCloseButton"
          [(ngModel)]="hasCloseButton">
        <label for="hasCloseButton" class="c-input-check-inline__label">Has Close Button</label>
        <input id="hasDefinedIcon" class="c-input-check-inline__input" type="checkbox" name="hasDefinedIcon"
          [(ngModel)]="hasDefinedIcon">
        <label for="hasDefinedIcon" class="c-input-check-inline__label">Has Defined Icon</label>
        <input id="hasModifiedIcon" class="c-input-check-inline__input" type="checkbox" name="hasModifiedIcon"
          [(ngModel)]="hasModifiedIcon">
        <label for="hasModifiedIcon" class="c-input-check-inline__label">Has Modified Icon</label>
      </div>
    </div>
    <div class="content__row">
      <input id="closeButtonArialabel" class="c-input-group__control" placeholder="Close Aria Label" type="text"
        name="closeButtonArialabel" [(ngModel)]="closeButtonArialabel">
      <label for="closeButtonArialabel" class="content__row-label">Close Aria Label</label>
      <input id="accordianOpenLabel" class="c-input-group__control" placeholder="Accordian Open Label" type="text"
        name="accordianOpenLabel" [(ngModel)]="accordianOpenLabel">
      <label for="accordianOpenLabel" class="content__row-label">Accordian Open Label</label>
      <input id="accordianCloseLabel" class="c-input-group__control" placeholder="Accordian Close Label" type="text"
        name="accordianCloseLabel" [(ngModel)]="accordianCloseLabel">
      <label for="accordianCloseLabel" class="content__row-label">Accordian Close Label</label>
      <input id="notificationModifiedIcon" class="c-input-group__control" label=" " placeholder="Notification Modified Icon Name" type="text"
        name="notificationModifiedIcon" [(ngModel)]="notificationModifiedIcon">
      <label for="notificationModifiedIcon" class="content__row-label">Notification Modified Icon Name</label>
    </div>
  </div>

  <maced-button buttonId="NotificationInlineButton" type="link"
    [queryParams]="{ notificationInlineId: 'notificationInlineId', isOpen: true }" label="Show Notification Inline"
    [url]="currentUrl">
  </maced-button>
  <div class="u-mt-16">
    <maced-notification-inline notificationInlineId="notificationInlineId" [type]="type" [hasDefinedIcon]="hasDefinedIcon"
      [hasModifiedIcon]="hasModifiedIcon" [notificationModifiedIcon]="notificationModifiedIcon"
      [closeButtonArialabel]="closeButtonArialabel" [hasCloseButton]="hasCloseButton" [hasAcordian]="hasAcordian"
      [accordianOpenLabel]="accordianOpenLabel" [accordianCloseLabel]="accordianCloseLabel" [ariaLabel]="ariaLabel"
      *ngIf="showNotificationInline">
      <ng-container ngProjectAs="[notificationInlineTitle]">
        <strong>Note:</strong>
        &nbsp;To add new course please visit
        <a class="c-link" href="https://www.macmillaneducationeverywhere.com" target="_blank">
          <span class="c-link__text">Macmillan Education Everywhere</span>
          <span>
            <svg class="svg-link" role="img" title="open in new window" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="16px" height="16px" viewBox="0 0 16 16"
              style="enable-background:new 0 0 16 16;" xml:space="preserve">
              <path id="path-1_1_"
                d="M9.5,2H13c0.6,0,1,0.4,1,1v3.5c0,0.6-0.4,1-1,1s-1-0.4-1-1V5.4L9.7,7.7C9.5,7.9,9.3,8,9,8S8.5,7.9,8.3,7.7
              c-0.4-0.4-0.4-1,0-1.4L10.6,4H9.5c-0.6,0-1-0.4-1-1S8.9,2,9.5,2z M11,10c0-0.6,0.4-1,1-1s1,0.4,1,1v1c0,2.2-1.8,4-4,4H5
              c-2.2,0-4-1.8-4-4V7c0-2.2,1.8-4,4-4h1c0.6,0,1,0.4,1,1S6.6,5,6,5H5C3.9,5,3,5.9,3,7v4c0,1.1,0.9,2,2,2h4c1.1,0,2-0.9,2-2V10z" />
            </svg>
          </span>
        </a>
      </ng-container>
      <ng-container ngProjectAs="[notificationInlineTabContent]">
        <p>
          Accordian Content
        </p>
      </ng-container>
      <ng-container ngProjectAs="[notificationInlineButton]">
        <maced-link id="link" [hasOpenLink]="true" [links]="link"></maced-link>
      </ng-container>
    </maced-notification-inline>
  </div>
</div>